export default __webpack_public_path__ + "static/interizon-4af1fdb29cb240edcb8e482049f50f48.jpeg";